import { RootState } from "store";
import { Store } from "@reduxjs/toolkit";

import type SpaceRepositoryInterface from "../../domain/space/space.repository.interface";
import type { SpaceEntity, SpaceFilter } from "../../domain/space/space.types";
import { generateTags } from "../../application/utils";

class SpaceRepository implements SpaceRepositoryInterface {
  constructor(private surveyStore: Store<RootState>) {}

  getSpaces(): SpaceEntity[] | null {
    const { spaces } = this.surveyStore.getState().spaceState;
    const spacesRemapped: SpaceEntity[] | null =
      spaces?.map((space, i) => {
        const tags = generateTags(space, i === 0);
        return { ...space, tags };
      }) ?? null;
    return spacesRemapped;
  }

  getSpaceFilters(): SpaceFilter[] | null {
    const { spaceFilters } = this.surveyStore.getState().spaceState;
    return spaceFilters;
  }

  getSpace(): SpaceEntity | null {
    const { currentSpace } = this.surveyStore.getState().spaceState;
    if (currentSpace) {
      const tags = generateTags(currentSpace);
      return { ...currentSpace, tags };
    }
    return null;
  }

  isLoadingSpace(): boolean {
    const { isLoadingSpace } = this.surveyStore.getState().spaceState;
    return isLoadingSpace;
  }

  isLoadingSpaces(): boolean {
    const { isLoadingSpaces } = this.surveyStore.getState().spaceState;
    return isLoadingSpaces;
  }

  isLoadingSpaceFilters(): boolean {
    const { isLoadingSpaceFilters } = this.surveyStore.getState().spaceState;
    return isLoadingSpaceFilters;
  }
}

export default SpaceRepository;
